export const VERSION = 29;
export const VERSION_WEB = "1.1.2";

//     + thay đổi logic
//     + fix lỗi không load bệnh viện trước khi lần đầu sử dụng
//     + fix logic xác nhận thông tin
//     + fix thanh toán vs momo ở xác nhận thông tin
//     + xử lý lại loading ở xác nhận
//     + xử lại wallat, reset tất cả feature, và tiến hành lấy mới,
//     + được MR từ testing mới nhất
//     + tích hợp tính năng mới như hiện tại
// VERSION = 29 momo live;
